module.exports = __webpack_public_path__ + "static/mpSpacePoster2-1-6a1c38798c7b92e17e66d19c71a0e24b.jpg";